import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModelWithUser } from './base';
import { EModel } from './model';

/**
 * Enum representing the possible statuses of the assistant action.
 */
export let EAssistantActionStatus;

/**
 * Interface for the assistant action, inheriting base user-related properties.
 */
(function (EAssistantActionStatus) {
  EAssistantActionStatus["Success"] = "success";
  EAssistantActionStatus["Failure"] = "failure";
})(EAssistantActionStatus || (EAssistantActionStatus = {}));
export const fieldsAssistantAction = _extends({}, fieldsIBaseModelWithUser, {
  assistantInstance: {
    type: 'ID',
    ref: EModel.AssistantInstance
  },
  description: {
    type: 'Text'
  },
  functionName: {
    type: 'Text'
  },
  namespace: {
    type: 'Text'
  },
  parameters: {
    type: 'Object'
  },
  response: {
    type: 'Unknown'
  },
  status: {
    type: 'Option',
    values: EAssistantActionStatus
  }
});